import { cn } from '@/lib/utils';
import { motion, type Variants } from 'motion/react';
import { useMemo } from 'react';
import type { TimebarAnimationVariant } from './models';
const getTimebarAnimations = ({
  duration,
  repeat,
  repeatType
}: {
  duration: number;
  repeat?: number;
  repeatType?: 'reverse' | 'loop' | 'mirror';
}): Variants => ({
  idle: {
    width: 0,
    opacity: 100
  },
  in_progress: {
    width: 'auto',
    opacity: 100,
    transition: {
      duration,
      ease: 'linear',
      repeat,
      repeatType
    }
  },
  completed: {
    width: 'auto',
    opacity: 100,
    transition: {
      duration: 0.8,
      ease: 'easeIn'
    }
  },
  interrupted: {
    width: 'auto',
    opacity: 0,
    transition: {
      duration: 0.4,
      ease: 'easeInOut'
    }
  }
});
export const Timebar = ({
  duration,
  animationVariant: timebarAnimationVariant,
  className,
  repeat,
  repeatType
}: {
  duration: number;
  repeat?: number;
  repeatType?: 'reverse' | 'loop' | 'mirror';
  animationVariant: TimebarAnimationVariant;
  className?: string;
}) => {
  const variants = useMemo(() => getTimebarAnimations({
    duration,
    repeat,
    repeatType
  }), [duration, repeat, repeatType]);
  if (!duration) {
    return;
  }
  return <div className={cn('h-2 w-full shrink-0 bg-gray-100 dark:bg-gray-800', className)} data-sentry-component="Timebar" data-sentry-source-file="timebar.tsx">
      <motion.div animate={timebarAnimationVariant} className="h-full rounded-r-md bg-pink-600 dark:bg-pink-500" initial="idle" variants={variants} data-sentry-element="motion.div" data-sentry-source-file="timebar.tsx" />
    </div>;
};